import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedTime} from "react-intl";

import {greyishBlue500} from "assets/jss/main";

DateAndAuthor.propTypes = {
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
    author: PropTypes.node.isRequired,
};

function DateAndAuthor({date, author}) {
    return (
        <span style={{color: greyishBlue500, lineHeight: 'normal'}}>
            <FormattedDate value={date} day='2-digit' month='2-digit'/>
            {' '}
            <FormattedTime value={date} hour='2-digit' minute='2-digit' hour12={false}/>
            {' · '}
            {author}
        </span>
    );
}

export default DateAndAuthor;
